<template>
  <DraggableVirtualList
    group="kanban"
    class="activity-board-column flex-1 pt-2"
    v-model="columnActivities"
    :data-key="'id'"
    :data-sources="columnActivities"
    :data-component="ItemComponent"
    :extra-props="{ onSelect }"
    :estimate-size="153"
    :keeps="30"
    :sort="false"
    ghost-class="activity-ghost"
    handle=".activity-handler"
  />
</template>
<script>

import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import DraggableVirtualList from 'vue-draggable-virtual-scroll-list';

import Activity from '@/febos/global/kanban/components/Activity';
import { getActivitiesOfBoard } from '@/febos/global/kanban/store/getters';
import { changeActivityStatus } from '@/febos/global/kanban/store/actions';

export default {
  data() {
    return {
      ItemComponent: Activity
    };
  },
  computed: {
    ...mapGetters('kanban', {
      getActivitiesOfBoard: getActivitiesOfBoard.name
    }),
    columnActivities: {
      get() {
        const activities = this.getActivitiesOfBoard(this.kanbanId, this.columnValue);
        const filters = Object.entries(this.onTheFlyFilters);
        if (filters.length) {
          return activities.filter((activity) => (
            filters.every(([filterKey, filterComparator]) => filterComparator(activity[filterKey]))
          ));
        }
        return activities;
      },
      set(value) {
        const [removed] = _.differenceBy(this.columnActivities, value, 'id');
        const [updated] = _.differenceBy(value, this.columnActivities, 'id');
        if (removed) {
          console.log('value added to this column', removed);
        }
        if (updated) {
          this.changeActivityStatus({
            activity: updated,
            kanbanId: this.kanbanId,
            statusValue: this.columnValue,
            statusName: this.columnName,
            companyStatusName: '--',
            companyStatusValue: '--'
          });
          console.log('value removed from this column', updated);
        }
      }
    }
  },
  methods: {
    ...mapActions('kanban', {
      changeActivityStatus: changeActivityStatus.name
    }),
    onSelect(activity) {
      this.$emit('select-activity', activity);
    }
  },
  components: { DraggableVirtualList },
  props: {
    kanbanId: { type: String, required: true },
    columnValue: { type: String, required: true },
    columnName: { type: String, required: true },
    onTheFlyFilters: { type: Object, default: () => {} }
  }
};

</script>
<style lang="scss">

.activity-board-column {
  background-color: #e9ecef;
  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, .1) !important;
  overflow-y: auto;

  > div,
  > div > div {
    position: relative;
    height: 100%;
  }
}

</style>
